import { deviceTypes } from 'z-js-commons';

export default {
    info: {
        title: 'CONFERMA O ANNULLA',
        description: "Clicca su 'Conferma e prosegui' per proseguire nella creazione dell'esercizio. Clicca su 'annulla' per anullare le modifiche fatte.",
        isActive: true,
        name: 'CreationStepsPageAnchor',
        tutorialName: 'creazione-esercizi_pulsantiera-steps'
    },
    [deviceTypes.DESKTOP]: {
        popoverPlacement: 'top',
        xPlacement: 'CENTER',
        yPlacement: 'MIDDLE'
    },
    [deviceTypes.PHONE]: {
        popoverPlacement: 'top',
        xOffset: 5
    }
};
